import { action, computed, makeObservable, observable } from "mobx";
import { ShopGood } from "../../../interfaces";
import { ShopGoodIncludeStore } from "../shop-good-include";
import { ShopGoodImageStore } from "../shop-good-image";
import { API } from "../../../core";

export class ShopGoodStore implements ShopGood {
	@observable id = 0;
	@observable sort = 0;
	@observable title = "";
	@observable rate = "";
	@observable payment_terms = "";
	@observable description = "";
	@observable shop_good_plans_id = 0;
	@observable shop_good_period_id = 0;
	@observable instrument_id = 0;
	@observable price_dollar = 0;
	@observable price_ruble = 0;
	@observable is_popular = false;
	@observable include_descriptions: ShopGoodIncludeStore[] = [];
	@observable images: ShopGoodImageStore[] = [];
	@observable grand_chart_id: number | null = null;

	constructor(initialData: ShopGood | null) {
		makeObservable(this);

		if (initialData) {
			this.fillStore(initialData);
		}
	}

	@computed
	get cover() {
		if (this.images.length === 0) {
			return null;
		}

		const pathCover = this.images.find((image) => image.is_cover);

		if (!pathCover) {
			return null;
		}

		return `${API.getFilesPath}${pathCover.file}`;
	}

	@action
	fillStore(data: ShopGood) {
		const {
			id,
			sort,
			title,
			rate,
			payment_terms,
			description,
			shop_good_plans_id,
			shop_good_period_id,
			instrument_id,
			price_dollar,
			price_ruble,
			is_popular,
			include_descriptions,
			images,
			grand_chart_id,
		} = data;

		this.id = id;
		this.sort = sort;
		this.title = title;
		this.rate = rate;
		this.payment_terms = payment_terms;
		this.description = description;
		this.shop_good_plans_id = shop_good_plans_id;
		this.shop_good_period_id = shop_good_period_id;
		this.instrument_id = instrument_id;
		this.price_dollar = price_dollar;
		this.price_ruble = price_ruble;
		this.is_popular = is_popular;
		this.include_descriptions = (include_descriptions || []).map(
			(include_description) => new ShopGoodIncludeStore(include_description),
		);
		this.images = (images || []).map((image) => new ShopGoodImageStore(image));
		this.grand_chart_id = grand_chart_id || null;
	}
}
